import Hoverable from 'components/Hoverable'
import Newsletter from 'components/Newsletter'
import Text from 'components/Text'
import TextBody from 'components/TextBody'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import { View } from 'components/View'
import { brandMessages } from 'messages/brand'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import {
  navItemsFooter,
  socialLinks
} from 'pages/Creators/Header/navItems.js'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Link from 'components/Link'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import getCurrentYearDateUtil from 'utils/date/get-current-year/index.js'
import shouldHideFooterRouterSelect from 'modules/router/selectors/should-hide-footer/index.js'
import shouldShowNewsletterSelect from 'modules/newsletter/redux/selectors/should-show/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { isOnlyInterestedInNutritionProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'

const messages = defineMessages({
  madeWithLoveAtTheGym: {
    id: 'Footer.madeWithLoveAtTheGym',
    defaultMessage: 'Made with {heart} at the gym'
  },
  copyright: {
    id: 'Footer.copyright',
    defaultMessage: 'Copyright © {currentYear} Gymaholic'
  }
})

function WhatIsGymaholic (props) {
  const intl = useIntl()
  return (
    <View f={2} {...props}>
      <TextTitleCondensed c='white'>
        {formatMessageIntlUtil(intl, brandMessages.whatsGymaholic)}
      </TextTitleCondensed>
      <TextBody
        c='white'
        mt
      >
        {formatMessageIntlUtil(intl, brandMessages.moveEatAndLiveBetter)}
      </TextBody>
      <TextBody
        c='white'
        mt
      >
        {formatMessageIntlUtil(intl, brandMessages.gymaholicDescription)}
      </TextBody>
    </View>
  )
}

export default function Footer ({ hasNewsletter }) {
  const shouldHideFooter = useSelector(shouldHideFooterRouterSelect)
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const shouldShowNewsletter = useSelector(shouldShowNewsletterSelect)
  const isInterestedInNutrition = useSelector(isOnlyInterestedInNutritionProfileSelect)

  const copyrightLabel = (
    formatMessageIntlUtil(intl, messages.copyright, {
      currentYear: getCurrentYearDateUtil()
    })
  )

  const madeWithLoveLabel = (
    formatMessageIntlUtil(
      intl,
      messages.madeWithLoveAtTheGym,
      { heart: '♥' }
    )
  )

  const Wrapper = ({
    children,
    ...rest
  }) => (
    <View
      m={isSmallScreen
        ? 'unset'
        : '0 auto'}
      w={isSmallScreen
        ? 'unset'
        : '960px'}
      row
      jc='space-between'
      {...rest}
    >
      {children}
    </View>
  )

  if (shouldHideFooter) {
    return <></>
  }
  return (
    <View
      bgc='#151D21'
      px={isSmallScreen
        ? '32px'
        : 0}
      py={isSmallScreen
        ? '40px'
        : '200px'}
    >
      <Wrapper
        jc='flex-start'
        mb={4}
        row={!isSmallScreen}
      >
        <WhatIsGymaholic />
        {
          !!hasNewsletter &&
          !!shouldShowNewsletter && (
            <View
              ml={isSmallScreen ? 0 : 2}
              mt={isSmallScreen ? 2 : 0}
              f
            >
              <Newsletter />
            </View>
          )
        }
      </Wrapper>

      <Wrapper>
        {
          !isSmallScreen && (
            <View
              f
              style={{ lineHeight: '22px' }}
            >
              <Text
                c='#ffffff'
                fs='13px'
                fw='590'
                style={{ textTransform: 'uppercase' }}
              >{madeWithLoveLabel}
              </Text>
              <Text
                c='#ffffff'
                fs='13px'
                fw='590'
                mt='5px'
                style={{ textTransform: 'uppercase' }}
              >
                {copyrightLabel}
              </Text>
            </View>
          )
        }

        <View
          style={{
            gap: '10px',
            flexDirection: isSmallScreen
              ? 'column'
              : 'row'
          }}
          f={2}
        >
          {navItemsFooter.map((navItem, index) => {
            if (isInterestedInNutrition && navItem.path === ROUTE_PATH.FAQ) {
              return null
            }
            return (
              <Hoverable key={navItem.path}>
                <Link
                  to={navItem.path}
                  style={{
                    padding: isSmallScreen
                      ? 0
                      : '0 10px',
                    paddingTop: 0
                  }}
                >
                  <Text
                    c='#FFFFFF'
                    fw='590'
                    fs='13px'
                    style={{
                      textTransform: 'uppercase'
                    }}
                  >{formatMessageIntlUtil(intl, navItem.name)}
                  </Text>
                </Link>
              </Hoverable>
            )
          })}
        </View>

        <View
          style={{ gap: '10px' }}
        >
          {
            socialLinks.map((navItem) => (
              <Hoverable key={navItem.path}>
                <a
                  target='_blank'
                  href={navItem.path}
                  rel='noreferrer'
                >
                  <Text
                    c='#FFFFFF'
                    fw='590'
                    fs='13px'
                    style={{
                      textTransform: 'uppercase'
                    }}
                  >
                    {formatMessageIntlUtil(intl, navItem.name)}
                  </Text>
                </a>
              </Hoverable>
            ))
          }
        </View>
      </Wrapper>

      {
        isSmallScreen && (
          <View
            style={{ lineHeight: '22px' }}
            mt='20px'
          >
            <Text
              c='#ffffff'
              fs='13px'
              fw='590'
              style={{ textTransform: 'uppercase' }}
            >{madeWithLoveLabel}
            </Text>
            <Text
              c='#ffffff'
              fs='13px'
              fw='590'
              mt='5px'
              style={{ textTransform: 'uppercase' }}
            >
              {copyrightLabel}
            </Text>
          </View>
        )
      }
    </View>
  )
}
